import CUserImageIcon from "../CUserImageIcon";
import React from 'react';
import Moment from "moment";
import { useIsPremiumUser } from "examsbook-react-sdk/custom-hooks";
import { useNavigate } from "react-router-dom";
import { Button } from '@material-ui/core';
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";
import { useSelector } from "react-redux";

function UserProfileView(props) {
    const { user, requestOtp } = props;
    const t = useTranslations();
    let imageUrl;
    if (user && user.image) {
        imageUrl = user.image.thumbnail && user.image.thumbnail.webP ?
            user.image.thumbnail.webP : '';
    }
    const isPremium = useIsPremiumUser();
    const navigate = useNavigate();
    const currentDate = new Date().toISOString();
    const expieryDate = user.premiumExpiry;
    const diff = Math.floor((Date.parse(expieryDate) - Date.parse(currentDate)) / 86400000);
    const appSettings = useSelector((state) => state.appSettings);
    const isPaymentEnabled = !!appSettings.paymentEnabled;
    return (
        <>
            <div className="profile-banner">
                {/* <div className="edit-data" onClick={toggleProfileUpdateModel}>
                <i className="fa fa-pencil"/>
            </div> */}
                <div className="profile-pic">
                    <CUserImageIcon src={imageUrl}/>
                </div>
            </div>
            <div className="profile-data">
                <div className="left-data">
                    <h4>{user.name}</h4>
                    {
                        isPaymentEnabled && <div>
                            <h4>{isPremium && (diff <= 7) ? <Button className="renew-plan">{t('RENEW_VIP')}</Button>
                                : isPremium ? <Button className="header-plan">{t('VIP')}</Button>
                                    : <Button className="header-become-plan"
                                              onClick={() => navigate('/my-app/payments')}>{t('GET_VIP')}</Button>
                            }</h4>
                            {isPremium ?
                                <h4>{t('VALID_TILL') + " "}{Moment(user.premiumExpiry).format('DD-MM-YYYY hh:mm:ss A')}</h4>
                                : ''}
                        </div>
                    }
                </div>
                <div className="right-data">
                    <p>
                        <i className="fa fa-envelope"/>
                        <span>{user.email || '-'}</span>
                    </p>
                    <p><i className="fa fa-phone"/>
                        <span>
                        {user.mobileNumber ? "+91 " + user.mobileNumber : '-'}
                            {user.mobileNumber ? user.isMobileVerified ? <i className="fa fa-check-circle"/> :
                                // eslint-disable-next-line
                                <button onClick={() => {
                                    requestOtp();
                                }}>
                                    <i className="fa fa-exclamation-circle"/>
                                </button> : null
                            }
                            {/* <button onClick={toggleMobileNumberModel}>
                                <i className="fa fa-edit"/>
                        </button> */}
                        </span>
                    </p>
                    <p><i className="fa fa-map-marker"/>
                        {user.city ?
                            <span>{user.city}</span>
                            : '-'}
                    </p>
                </div>
            </div>
        </>
    );
}

export default UserProfileView;
